// @ts-nocheck

import { has } from 'lodash';

import { BasketActionTypes } from '../../types/actions/basket';
import { MyMatchActionTypes } from '../../types/actions/mymatch';
import { NetworkActionTypes } from '../../types/actions/network';
import { StudioActionTypes } from '../../types/actions/studio';
import { type HandlerProps } from '../synchronousMiddleware';

export const handledActionTypes = [
  BasketActionTypes.ADD_ITEM,
  BasketActionTypes.ADD_BETBUILDER_ITEM,
  BasketActionTypes.DEL_ITEM,
  BasketActionTypes.CLEAR,
  MyMatchActionTypes.MERGE,
  MyMatchActionTypes.SPLIT,
];

const studioAppMiddlewareHandler = ({ store: { getState }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    const hasRouteChanged = action.type === NetworkActionTypes.SEND && has(action.payload, 'route');

    if (
      ~[
        BasketActionTypes.ADD_ITEM,
        BasketActionTypes.ADD_BETBUILDER_ITEM,
        BasketActionTypes.DEL_ITEM,
        BasketActionTypes.CLEAR,
        MyMatchActionTypes.MERGE,
        MyMatchActionTypes.SPLIT,
      ].indexOf(action.type) ||
      hasRouteChanged
    ) {
      if (window.parent !== window) {
        if (hasRouteChanged) {
          window.parent.postMessage(
            {
              type: StudioActionTypes.ROUTE_CHANGED,
              payload: action.payload,
            },
            '*',
          );
        } else {
          window.parent.postMessage(
            {
              type: `winabet/${action.type}`,
              payload: {
                origin: action,
                data: getState().entities,
              },
            },
            '*',
          );
        }
      }
    }
  }
};

export default studioAppMiddlewareHandler;
